import React from 'react';
import styled from 'styled-components';

import paginaEmConstrucao from '../../assets/construcao.png';

const DivComponent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 3rem;
  gap: 0px;
`;

// Ajustando o componente para receber e mapear as SubAbas
const PageBuilding: React.FC = () => {
  return (
    <DivComponent>
      <img
        src={paginaEmConstrucao}
        alt="Imagem simbolizando Página em Construção"
      />
      Página em construção!
    </DivComponent>
  );
};

export default PageBuilding;
